// extracted by mini-css-extract-plugin
module.exports = {"container":"dashboard_container__1w-Qt","content":"dashboard_content__3YTJS"};